module.exports = __webpack_public_path__ + "static/media/work-5.204434ef.jpg";